import React from 'react';
import { Box, Typography, Card, CardContent, CardActions, Button, Grid, Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const assessments = [
    { 
        id: 'technical', 
        title: '1. Technical Assessment', 
        description: 'Covers core role-specific knowledge and skills.', 
        color: 'primary'
    },
    { 
        id: 'aptitude', 
        title: '2. Aptitude & Reasoning', 
        description: 'Tests logical ability, problem-solving, and quantitative skills.', 
        color: 'secondary'
    },
    { 
        id: 'behavioural', 
        title: '3. Behavioural & Communication', 
        description: 'Evaluates soft skills, teamwork, and situational judgment.', 
        color: 'info'
    },
];

function AssessmentLanding({ onStartTest, completedTests, isAssessmentComplete, onViewResults }) {
    return (
        <Box 
            sx={{ 
                p: { xs: 1, md: 2 }, 
                backgroundColor: 'white', 
                borderRadius: 2, 
                boxShadow: 3,
                // FLEXBOX FOR NO SCROLL: Center content vertically
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                flexGrow: 1, // Take full height
            }}
        >
            <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ fontWeight: 700, mb: 3, color: 'primary.dark' }}>
                Select Your Assessment Section
            </Typography>
            
            <Grid container spacing={2} justifyContent="center" sx={{ maxWidth: '900px' }}>
                {assessments.map((assessment) => {
                    const isCompleted = completedTests[assessment.id];
                    return (
                        <Grid item xs={12} sm={6} md={4} key={assessment.id}>
                            <Card 
                                elevation={isCompleted ? 0 : 4} 
                                sx={{ 
                                    height: '100%', 
                                    display: 'flex', 
                                    flexDirection: 'column',
                                    border: isCompleted ? '2px solid' : '1px solid',
                                    borderColor: isCompleted ? `${assessment.color}.main` : 'divider',
                                    backgroundColor: isCompleted ? `${assessment.color}.light` : 'white',
                                }}
                            >
                                <CardContent sx={{ flexGrow: 1, pb: 1 }}>
                                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                        <Typography variant="h6" component="div" sx={{ fontWeight: 600, color: `${assessment.color}.dark` }}>
                                            {assessment.title}
                                        </Typography>
                                        {isCompleted && (
                                            <CheckCircleIcon sx={{ color: `${assessment.color}.main` }} />
                                        )}
                                    </Box>
                                    <Typography variant="body2" color="text.secondary">
                                        {assessment.description}
                                    </Typography>
                                </CardContent>
                                <CardActions sx={{ justifyContent: 'flex-end', pt: 0, pb: 1.5 }}>
                                    <Button
                                        variant={isCompleted ? 'outlined' : 'contained'}
                                        color={assessment.color}
                                        size="small"
                                        disabled={isCompleted}
                                        onClick={() => onStartTest(assessment.id)}
                                    >
                                        {isCompleted ? "Completed" : "Start Test"}
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>

            {/* View Final Results Button */}
            {isAssessmentComplete && (
                <Box sx={{ mt: 3, textAlign: 'center' }}>
                    <Button
                        variant="contained"
                        color="secondary" 
                        size="large"
                        sx={{ py: 1.2, px: 4, fontSize: '1.1rem', fontWeight: 700 }} 
                        onClick={onViewResults}
                    >
                        View Combined Results
                    </Button>
                </Box>
            )}

            {!isAssessmentComplete && (
                <Typography variant="body2" align="center" sx={{ mt: 2, color: 'text.secondary' }}>
                    *Results will be displayed only after all three assessment sections are completed.
                </Typography>
            )}
        </Box>
    );
}

export default AssessmentLanding;